// Brand palette, sampled from the logo. Only these three hues are used as
// section backgrounds anywhere on the site — everything else here is a tint,
// shade or opacity variant of one of them for borders/shadows/dividers.
//
// NOTE: these values are mirrored in src/styles/colors.css as CSS custom
// properties (--orange, --red, etc.) for use in App.css. Keep both in sync.
export const COLORS = {
  orange: "#f59d0e",
  orangeDark: "#d0850b",
  orangeSoft: "#fdecc8",
  red: "#bf2727",
  redDark: "#9c1f1f",
  redSoft: "#f7d9d9",
  white: "#fefefe",
  ink: "#2a1a12",
  muted: "#6b5a4a",
};

// Converts a "#rrggbb" hex color to an "rgba(r, g, b, alpha)" string, for
// building translucent overlays (hero photo tint, shadows) from the palette
// above instead of hardcoding separate rgba literals.
export function hexToRgba(hex, alpha = 1) {
  const value = hex.replace("#", "");
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
